<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <remaining class="text-end" :total="total" :used="used"></remaining>

    <b-row>
      <b-col sm="4">
        <search-product-card @save="$refs.researchTable.refresh()"/>
      </b-col>
      <b-col sm="8">
        <b-card no-body
                class="table-responsive"
                title-class="font-18"
                :title="$t('pages.product_research.search_product_modal.title')"
        >
          <b-card-body>
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-6 col-12">
                  <PerPageSelector v-model="query.perPage"
                                   :available-per-page-options="availablePerPageOptions"
                  ></PerPageSelector>
                </div>
                <div class="col-sm-3 offset-lg-3 offset-md-3 offset-sm-3 col-12">
                  <DataTableSearch v-model="query.filter"
                                   :place-holder="$t('pages.product_research.search')">
                  </DataTableSearch>
                </div>
              </div>
            </div>
            <b-table
                class="table-centered align-middle"
                ref="researchTable"
                striped
                hover
                :empty-text="$t('components.bootstrap_table.empty_text')"
                :empty-filtered-text="$t('components.bootstrap_table.empty_filtered_text')"
                show-empty
                :fields="fields"
                :items="getSearches"
                :stacked="$store.state.app.isMobile"
                :filter="query.filter"
                :per-page="query.perPage"
                :sort-by="query.sortBy"
                :sort-desc="query.sortDesc"
                :current-page="query.page"
            >
              <template #cell(media)="data">
                <div class="list-group list-group-flush">
                  <div class="media align-items-center">
                    <div class="me-3">
                      <b-avatar square size="6em" :src="data.item.media.url"></b-avatar>
                    </div>
                    <div class="media-body overflow-hidden">
                      <h5 class="font-size-13">
                        {{ data.item.search.toUpperCase() }}
                      </h5>
                      <market-place-chip class="mb-3" :market-place-id="data.item.marketplace_id"></market-place-chip>
                    </div>
                  </div>
                </div>

              </template>

              <template #cell(created_at)="data">
                <p class="pt-2"> {{ data.item.created_at | date }}</p>
              </template>

              <template #cell(total_items)="data">
                <checked-data :flag="data.item.status !== 'processing'">
                  <h5>
                <span class="badge badge-soft-secondary">
              {{ data.item.total_items }}
                </span>
                  </h5>
                </checked-data>
              </template>

              <template #cell(action)="data">
                <b-btn size="sm" variant="primary" disabled v-if="data.item.status === 'processing'">
                  <b-spinner small></b-spinner>
                  <span class="mx-2">{{ data.item.status.toUpperCase() }}</span>
                </b-btn>
                <b-btn v-else variant="primary"
                       @click="$router.push({name: 'product.research.show', params: {matchId : data.item.id}})"
                       size="sm">
                  <i class="mdi mdi-eye"></i>
                  {{ $t('pages.product_research.show_detail') }}
                </b-btn>
              </template>
            </b-table>
            <div class="row">
              <div class="col-sm">
                <Pagination v-model="query.page" :meta="searches.meta"></Pagination>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import queryBuilder from "../../../mixins/queryBuilder";
import SearchProductCard from "./Components/SearchProductCard";
import MarketPlaceChip from "../../../components/widgets/MarketPlaceChip";
import PerPageSelector from "../../../components/PerPageSelector";
import ProductResearchService from "../../../Services/Api/ProductResearchService";
import QuotaMixin from "../../../mixins/QuotaMixin";

export default {
  components: {PerPageSelector, MarketPlaceChip, SearchProductCard},
  page() {
    return {
      title: this.$t('pages.product_research.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  name: "ProductResearch",
  mixins: [queryBuilder, QuotaMixin],
  data() {
    return {
      title: this.$t('pages.product_research.title'),
      items: [
        {
          text: this.$t('pages.product_research.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.product_research.items.second'),
          active: true,
        },
      ],
      fields: [
        {key: 'media', sortable: false, label: this.$t('pages.product_research.fields.product')},
        {key: 'created_at', sortable: false, label: this.$t('pages.product_research.fields.date')},
        {key: 'total_items', sortable: false, label: this.$t('pages.product_research.fields.total_items')},
        {key: 'action', sortable: false, label: this.$t('pages.product_research.fields.action')},
      ],
      searches: {},
      user: null,
      quotaType: 'product_research',
    };
  },
  methods: {
    startBroadcast() {
      window.Echo.private(`user-${this.user.id}`).listen('.research.refresh', () => {
        this.$store.dispatch('quota/getSubscriptionQuota')
        this.$refs.researchTable.refresh();
      })
    },
    stopBroadcast() {
      window.Echo.private(`user-${this.user.id}`).stopListening('.research.refresh')
    },
    async getSearches(params = this.query) {
      this.query = {...this.query, ...params}
      const query = this.buildQuery()
      const {data: searches} = await ProductResearchService.all({query})
      this.searches = searches
      return searches.data
    },
  },
  mounted() {
    this.$auth.load().then(() => {
      this.user = this.$auth.user()
      this.startBroadcast()
    })
  },
  beforeDestroy() {
    this.stopBroadcast()
  }
};
</script>
<style scoped>
</style>